import React, { useContext } from "react";
import { Box, Typography, Paper, Divider, Grid } from "@mui/material";
import {
  Assignment as AssignmentIcon,
  TrendingDown as TrendingDownIcon,
  CheckCircle as CheckCircleIcon,
  List as ListIcon,
} from "@mui/icons-material";

import { RetornoLoteContext } from "../../Context/RetornoLoteContext";
import GlosaItem from "../GlosaItem";

export default function GlosaList({ disabled = false }) {
  const { glosas } = useContext(RetornoLoteContext);

  const totalItens = glosas?.length || 0;

  const valorTotal =
    glosas?.reduce(
      (acc, item) => acc + (Number(item.valor_recebido) || 0),
      0
    ) || 0;

  if (!glosas || glosas.length === 0) {
    return (
      <Paper
        sx={{
          p: 4,
          textAlign: "center",
          backgroundColor: "#f8f9fa",
          border: "1px solid #e3f2fd",
          borderRadius: 2,
        }}
      >
        <AssignmentIcon sx={{ fontSize: 48, color: "#003399", mb: 2 }} />
        <Typography variant="h6" sx={{ color: "#003399", mb: 1 }}>
          Nenhum item adicionado
        </Typography>
        <Typography variant="body2" sx={{ color: "#757575" }}>
          Clique no botão "+" para adicionar um novo item
        </Typography>
      </Paper>
    );
  }

  return (
    <Box>
      <Paper
        sx={{
          p: 2,
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ListIcon sx={{ fontSize: 24 }} />
            <Typography
              variant="h6"
              sx={{
                color: "#003399",
                fontWeight: 600,
              }}
            >
              Itens ({totalItens})
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <TrendingDownIcon sx={{ color: "#003399", fontSize: 18 }} />
            <Typography variant="body2" sx={{ color: "#000", fontWeight: 500 }}>
              R${" "}
              {valorTotal.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box
        sx={{
          overflowY: "auto",
          maxHeight: "500px",
          scrollbarWidth: "thin",
          paddingRight: "0.5rem",
          scrollbarColor: "#003399 #fafafa",
        }}
      >
        {glosas.map((item, index) => (
          <GlosaItem
            key={item.id}
            item={item}
            index={index}
            disabled={disabled}
          />
        ))}
      </Box>
    </Box>
  );
}
